<div class="contas-pagar-container">
  <div class="card-box">
    <div class="card-cabecalho-bar">
      <div class="card-cabecalho-texto">
        <span class="card-cabecalho-titulo">{{ id > 0 ? 'Editar Conta a Pagar' : 'Cadastrar Conta a Pagar' }}</span>
        <span class="card-cabecalho-subtitulo">Preencha os dados financeiros para lançamento e acompanhamento do pagamento.</span>
      </div>
      <div class="top-highlight-field">
        <label class="form-label">Previsão/Real</label>
        <select class="form-control" [(ngModel)]="previsaoReal">
          <option value="P">Previsão</option>
          <option value="R">Real</option>
        </select>
      </div>
    </div>

    <div class="row g-2 formulario-compacto">
      <div class="col-md-2">
        <label class="form-label">Documento *</label>
        <select class="form-control" [(ngModel)]="idFinDocumento">
          <option [ngValue]="0">Selecione</option>
          <option *ngFor="let item of documentos" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label">Pagar para Fornecedor *</label>
        <select class="form-control" [(ngModel)]="idFinFornecedorRecebedor" (ngModelChange)="onFornecedorChange()">
          <option [ngValue]="0">Selecione</option>
          <option *ngFor="let item of fornecedores" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label">Plano de Contas *</label>
        <app-select-busca [opcoes]="planosContas" [(ngModel)]="idPlanoContas"></app-select-busca>
      </div>
      <div class="col-md-2">
        <label class="form-label">Centro de Custos</label>
        <select class="form-control" [(ngModel)]="idCentroCusto">
          <option [ngValue]="0">Selecione</option>
          <option *ngFor="let item of centrosCustos" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label">Parcela</label>
        <input type="number" min="1" class="form-control" [(ngModel)]="parcela" />
      </div>
      <div class="col-md-2 col-6">
        <label class="form-label" for="pagoPagar">Pago</label>
        <div class="toggle-container">
          <label class="toggle-switch">
            <input type="checkbox" id="pagoPagar" [(ngModel)]="pago" />
            <span class="toggle-slider"></span>
          </label>
          <span class="toggle-label">{{ pago ? 'Sim' : 'Não' }}</span>
        </div>
      </div>

      <div class="col-12 section-title">Datas e pagamento</div>
      <div class="col-md-3">
        <label class="form-label">Data Emissão *</label>
        <input type="date" class="form-control" [(ngModel)]="dataEmissao" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Data Vencimento</label>
        <input type="date" class="form-control" [(ngModel)]="dataVencimento" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Data Pagamento</label>
        <input type="date" class="form-control" [(ngModel)]="dataPagamento" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Tipo Pagamento</label>
        <div class="input-group">
          <select class="form-control" [(ngModel)]="idTipoPagamento">
            <option [ngValue]="0">Selecione</option>
            <option *ngFor="let item of tiposPagamento" [ngValue]="item.id">{{ item.descricao }}</option>
          </select>
          <button type="button" class="btn btn-outline-primary" title="Cadastrar tipo de pagamento" (click)="abrirModalTipoPagamento(modalTipoPagamento)">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
      <div class="col-md-3">
        <label class="form-label">Banco</label>
        <div class="input-group">
          <select class="form-control" [(ngModel)]="banco">
            <option [ngValue]="null">Selecione</option>
            <option *ngFor="let item of bancos" [ngValue]="item.id">{{ item.descricao }}</option>
          </select>
          <button type="button" class="btn btn-outline-primary" title="Cadastrar banco" (click)="abrirModalBanco(modalBanco)">
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>

      <div class="col-12 section-title">Valores</div>
      <div class="col-md-3">
        <label class="form-label">Vlr. Documento *</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorDocumento" (blur)="calcularValorPago()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Vlr. Imposto</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorImposto" (blur)="calcularValorPago()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Vlr. Outras Despesas</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorOutrasDespesas" (blur)="calcularValorPago()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Vlr. Desconto</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorDesconto" (blur)="calcularValorPago()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Vlr. Multa</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorMulta" (blur)="calcularValorPago()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Vlr. Custas</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorCustas" (blur)="calcularValorPago()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Vlr. Juros</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorJuros" (blur)="calcularValorPago()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Vlr. Custas Parcial</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorCustasParcial" (blur)="calcularValorPago()" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Taxa Juros/Dia</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="taxaJuroSdia" />
      </div>
      <div class="col-md-3">
        <label class="form-label">Vlr. Pago</label>
        <input type="number" step="0.01" class="form-control" [(ngModel)]="valorPago" />
      </div>
      <div class="col-12 valores-calcular-wrap">
        <button type="button" class="btn btn-sm btn-outline-primary valores-calcular-btn" (click)="calcularValorPago()">
          <i class="fa fa-calculator"></i> Calcular Vlr. Pago
        </button>
      </div>

      <div class="col-12">
        <label class="form-label">Observações</label>
        <textarea class="form-control" rows="2" [(ngModel)]="observacao"></textarea>
      </div>
    </div>

    <div class="acoes">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="voltar()">
        <i class="fa fa-arrow-left"></i> Voltar
      </button>
      <button type="button" class="btn btn-sm btn-success" (click)="salvar()">
        <i class="fa fa-save"></i> Salvar
      </button>
    </div>
  </div>

  <ng-template #modalTipoPagamento let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Novo Tipo de Pagamento</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <label class="form-label">Descrição *</label>
      <input
        type="text"
        class="form-control"
        maxlength="250"
        [(ngModel)]="novoTipoPagamentoDescricao"
        (keyup.enter)="salvarTipoPagamento(modal)"
        placeholder="Ex.: PIX, Boleto, Cartão de crédito" />
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
      <button type="button" class="btn btn-success" (click)="salvarTipoPagamento(modal)">
        <i class="fa fa-save"></i> Salvar
      </button>
    </div>
  </ng-template>

  <ng-template #modalBanco let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Novo Banco</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <label class="form-label">Nome do banco *</label>
      <input
        type="text"
        class="form-control"
        maxlength="100"
        [(ngModel)]="novoBancoDescricao"
        (keyup.enter)="salvarBanco(modal)"
        placeholder="Ex.: Santander, Banrisul" />
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
      <button type="button" class="btn btn-success" [disabled]="salvandoBanco" (click)="salvarBanco(modal)">
        <i class="fa fa-save"></i> Salvar
      </button>
    </div>
  </ng-template>
</div>
